<template>
  <div id="management" >
    <div class="title" >待参赛</div>
    <van-cell-group>
      <van-cell title="某某战队" is-link />
      <van-cell title="某某战队" is-link />
      <van-cell title="某某战队" is-link />
      <van-cell title="某某战队" is-link />
    </van-cell-group>
    <div class="title " >报名审核</div>
    <van-cell title="某某战队" is-link />
    <div class="title " >审核通过</div>
    <van-cell title="某某战队" is-link />
    <div class="title " >审核未通过</div>
    <van-cell title="某某战队" is-link />
    <div class="createTeam" >创建球队</div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Cell, CellGroup } from 'vant'
Vue.use(Cell, CellGroup)
export default {
  name: 'TeamManagement',
  data() {
    return {}
  },
  mounted () {},
  methods: {},
  computed: {}
}
</script>
<style>
  #management .title {
    padding: 10px 15px;
    background-color: #bfcdd9;
    font-size: 16px;
    margin-top: 15px;
  }

  #management .title:first-child {
    margin-top: 0;
  }

  #management .createTeam {
    font-size: 18px;
    padding-top: 20px;
    padding-right: 15px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/team-manmagement.vue